import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import UnitDetails from "./Unit.Floorplan";
import InfoUnit from "./InfoUnit";
import { unitIconLight, virtualIconLight, unitMapIconLight, unitIconGreen, virtualIconGreen, unitMapIconGreen } from "./styles";
import { floorplanActions } from "../../../../../_actions";
import VirtualTour from "./VirtualTour.Floorplan";
import EngrainMap from "../../../Utility/EngrainMap/EngrainMap";
import { QuickLinksWrapper } from "../../../List/styles";
import Carousel from "react-multi-carousel";
import { quickLinkTypes } from "../../../List/quickLinkTypes";
import { leftBackArrow, leftBackArrowEmbedded } from "../Components/styles";
import { useWindowSize } from "../../../Utility/hooks";
import { language, translate } from "../../../../../_helpers/general.helper";

import { DescImg, Description } from "./styles";

const UnitListFloorplansWrapper = styled.div`
  height: calc(100vh - 90px);
  width: 100vw;
  overflow: hidden;
  top: 60px;
  z-index: 1000000;
  background: #fff;
  flex: 1;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  .QuickLinksWrapper {
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding: 0;
    display: flex;
    justify-content: center;
    background: white;
    z-index: 1;
    border-top: 1px solid #d1d1d1;

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      border-top: none;
      padding-top: 15px !important;
      padding-bottom: 0 !important;
    }
  }

  .intents-wapper {
    align-items: center;
    height: 95px;
    display: flex;
    align-items: end;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      height: 60px;
    }

    .BackQuickLinkText {
      width: unset;
    }
  }

  .back-floorplan {
    font-weight: normal;
    color: #0f0538;
    background: #fff;
    width: 170px;
    border-radius: 50px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: space-between;
    background: #f0f0f0;
    color: #0f0538;
    font-size: 16px;
    font-weight: 600;

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakSmall}) {
      width: 200px;
    }
  }

  .QuickLinkText {
    width: 170px !important;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    .QuickLinkText {
      width: 200px !important;
    }

    .QuickLinksWrapper {
      margin-right: 0 !important;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 100%;
    height: calc(100% - 35px);
    border-radius: 30px;
  }

  .floorplan-image-wrapper {
    position: relative;
    height: 250px;
    display: flex;
    flex-direction: column-reverse;
    transition: all 0.5s;
    background: var(--Primary-LightGray, #f7f9fa);

    .floorplan-image {
      width: 50px;
      height: 50px;
      left: 50px;
      top: 60px;
      border-radius: 4.66px;
      border: 0.583px solid #dfdfdf;
      background: var(--Primary-White, #fff);
      box-shadow: 1.748px 1.748px 3.495px 0px rgba(169, 169, 169, 0.25);
    }

    .floorplan-image-animate {
      width: auto;
      height: 180px;
      position: absolute;
      transition: all 0.3s;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -65%);

      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakSmall}) {
        transition: all 0.2s;
        width: 120px;
        height: auto;
      }
    }

    &.floorplan-image-wrapper-embedded {
      background: #d0f4ff;
      height: 90px;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      gap: 20px;
      padding: 20px;
      position: fixed;
      width: 100%;

      .info-image {
        height: 24px;

        @media screen and (min-width: ${(props) =>
            props.theme.screenSizes.breakSmall}) {
          height: 22px;
        }
      }

      .floorplan-image-animate {
        height: 70px;
        position: relative;
        top: unset !important;
        left: unset !important;
        transform: unset !important;
      }

      .embeded-back-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakLaptop}) {
        width: 1300px;
        justify-content: center;
        padding-left: 150px;
        height: 120px;

        .floorplan-image-animate {
          height: 90px;
        }

        .embeded-back-button {
          position: absolute;
          left: 50px;
        }
      }
    }

    .info-wrapper {
      display: flex;
      justify-content: center;
      gap: 20px;
      padding-bottom: 7px;
      flex-wrap: wrap;
      justify-content: center;

      .floorPlanName {
        white-space: nowrap;
        width: 100%;
        text-align: start;
        color: #0f0538;
        font-family: "DM Sans";
        font-size: 16px;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: calc(100% - 10px);
      }

      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakSmall}) {
        justify-content: start;
        margin-top: 10px;
        align-items: center;
        gap: 0px;
      }

      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakLaptop}) {
        margin-top: 0;
        height: 90px;

        .floorPlanName {
          font-size: 20px;
        }
      }
    }
  }
  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    &.virtualTour,
    &.unitMap {
      .tab-container {
        top: 63px !important;
      }

      .info-wrapper {
        padding-bottom: 0;
        margin-top: 0;
      }

      .floorplan-image-wrapper-embedded {
        height: 63px !important;

        .embeded-back-button {
          flex-direction: row;
        }

        .info-wrapper {
          flex: 1;
        }

        .floorplan-image {
          display: none;
        }

        .Description {
          display: none;
          margin-right: 10px;
        }
      }
    }
  }

  .back-button-floorplan {
    height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fafafa;
    position: relative;
    color: #49536c;
    font-family: "DM Sans";
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;

    .arrow-back {
      position: absolute;
      left: 20px;
      cursor: pointer;
      display: inline-block;
    }

    .florplan-name {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-left: 30px;
      width: 75%;
    }
  }

  @media screen and (max-height: 700px) and (max-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    .floorplan-image-wrapper {
      height: 180px;

      .floorplan-image {
        height: 115px;
        top: 45% !important;
      }
    }
  }

  .floorplan-terms {
    height: 48px;
    background: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #263b67;
    font-family: "DM Sans";
    font-size: 13px;
    font-weight: 500;

    & span {
      font-weight: 700;
      margin-right: 5px;
    }
    @media screen and (min-width: ${(prop) =>
        prop.theme.screenSizes.breakLaptop}) {
      position: relative;
      top: 75px;
    }
  }

  .embeded-term {
    color: var(--Text-color-text, #263b67);
    font-family: "DM Sans";
    font-size: 12px;
    font-weight: 500;
    width: 100%;
    text-align: start;
    margin-bottom: 3px;

    span {
      margin-right: 5px;
      font-weight: 700;
    }

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      margin-bottom: 7px;
    }
  }

  .Description {
    margin-right: 15px;
  }

  .info-description {
    margin-top: 0;
  }
`;

const UnitList = styled.div`
  overflow: hidden;
  height: 90%;
  overflow-y: auto;
  margin-bottom: 5px;
  flex: 1;
  padding-bottom: 170px;

  &.hasExpanded {
    overflow: hidden;
  }
  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    padding-bottom: 0;
  }

  :has(.expanded) .show-more-btn {
    pointer-events: none;
  }

  ::-webkit-scrollbar {
    width: 6px;
    border-radius: 24px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f7f9fa;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 24px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    height: calc(100% - 75px);
    flex: unset;
    position: relative;
    top: 75px;
    padding-bottom: 80px;
  }

  @media screen and (min-height: 900px) and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    top: 80px;
    height: calc(100% - 80px);
  }
`;

const UnitCarousel = styled(Carousel)`
  display: block;
  height: 455px;
  height: 100%;
  flex: 1;
  align-items: start !important;

  .react-multiple-carousel__arrow {
    bottom: 10px;
    background: #f1f1f1;
  }

  .react-multiple-carousel__arrow:hover {
    background: #fff;
  }

  .react-multiple-carousel__arrow:before {
    color: black;
  }
  .Engrain {
    display: block;
    height: 100% !important;
    svg {
      height: 100%;
    }

    .main {
      height: calc(100% - 60px) !important;
    }
  }

  .react-multi-carousel-list {
    align-items: start;
  }

  .react-multi-carousel-track {
    height: calc(100% - 70px);
  }
`;

const TabsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: end;
  height: 48px;
  border-bottom: 1px solid #ddd;

  background: white;

  position: sticky;
  position: -webkit-sticky;
  top: -1px;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    top: 90px;
    margin: 0 25px 100px 25px;
  }
  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    top: 120px;
    margin: 0 auto 130px auto;
    width: 80%;

    &.other-tabs {
      margin: 0 auto 80px auto;
    }
  }
`;
const Tab = styled.div`
  width: 100%;
  height: 45px;
  font-family: "DM Sans";
  font-size: 15px;
  font-weight: 500;
  align-items: center;
  justify-content: center;
  color: #91979d;
  position: relative;
  bottom: -2px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  cursor: pointer;

  .tab-name {
    text-wrap: nowrap;
  }

  .light-icon {
    display: none;
  }

  &.active-tab {
    border-bottom: 3px solid var(--Primary-Blue);
    bottom: -2px;
    height: 40px;
    font-weight: 700;

    color: black;
    .dark-icon {
      display: none;
    }

    .light-icon {
      display: block;
    }
  }

  &.active-tab {
    color: #fff;
    color: var(--Primary-Blue);
    border-bottom: 3px solid var(--Primary-Blue);
    outline-bottom: 3px solid var(--Primary-Blue);
  }

  &:hover {
    border-bottom: none;
  }

  &.disable-tab {
    pointer-events: none;
    border-bottom: none;
    color: #c4c8cb;
    justify-content: start;
    pointer-events: none;

    color: var(--Primary-Dark-Blue, var(--Primary-DarkBlue, #0f0538));
    font-size: 16px;
    font-weight: 700;
    padding-left: 25px;

    .dark-icon {
      display: block;
    }

    .light-icon {
      display: none;
    }
  }
`;

const MapWrapper = styled.div`
  height: calc(100% - 70px);
  background: white;
  position: relative;
  margin: 20px;
  border: 1px solid #f1f1f1;
  border-radius: 8px;
  box-shadow: 3px 3px 6px 0px rgba(169, 169, 169, 0.25);
  .carousel-caption {
    color: black;
  }

  .carousel-indicators {
    li {
      background: black;
      border: none;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }

  .carousel-control-next,
  .carousel-control-prev /*, .carousel-indicators */ {
    filter: invert(100%);
  }

  .carousel-control-prev,
  .carousel-control-next {
    align-items: end;
    padding-bottom: 10px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    height: calc(100% - 150px);
    margin-bottom: 0;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    margin: 0 15%;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    height: calc(100% - 130px);
  }

  .loading-wrapper {
    background: white;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1001;
    border-radius: 8px;
  }
`;
const Loading = styled.img`
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 99;
  top: 40%;
  transform: translateY(-50%);
  @media screen and (max-width: ${(props) =>
      props.theme.screenSizes.breakXsmall}) {
    width: 50%;
  }
  @media screen and (max-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    width: 50%;
  }
`;

const EmptyState = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  margin-top: 40px;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  position: absolute;
  background: #fff;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    margin-top: 50px;

    .redirect-title {
      font-size: 24px;
      font-weight: 500;
    }
  }

  span {
    color: #666;
    font-family: "DM Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: capitalize;
    margin-bottom: 25px;
  }

  .notify-button .QuicklinkButton {
    display: flex;
    justify-content: center;
  }

  .notify-button .QuickLinkText,
  .notify-button-redirect {
    display: flex;
    width: 200px;
    height: 43px;
    padding: 10px 15px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 30px;
    background-color: #42accd !important;
    color: #fff;
    font-family: "DM Sans";
    font-size: 16px;
    font-weight: 500;
    border: none;
    span {
      color: white;
      margin-bottom: 0;
    }
  }

  .no-units-redirect {
    width: 70%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  @media screen and (max-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    .no-units-redirect {
      font-size: 14px;
      width: 70%;

      .redirect-title {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  @media screen and (max-height: 700px) and (max-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    .notify-button {
      margin-top: -30px;
    }

    .no-units-redirect {
      gap: 8px;
      font-size: 14px;
      width: 70%;

      .redirect-title {
        font-size: 16px;
        font-weight: bold;
      }

      .notify-button-redirect {
        height: 34px;
        font-size: 14px;
      }
    }
  }
`;

const pendingState = {
  noPending: "no-pending",
  pending: "pending",
};

function UnitListFloorplans({
  data,
  activeTab,
  setActiveTab,
  getUnitsData,
  floorplanUnits,
  setUnit,
  activeUnit,
  unitMap,
  backFloorplans,
  mapLoading,
  floorplan,
  quickLinks,
  tid,
  unit,
  lang,
  newBranding
}) {
  const { width } = useWindowSize();
  const responsive = {
    allSizes: {
      breakpoint: { max: 5000, min: 0 },
      items: 1,
    },
  };

  const isStudent = floorplan.bot_type === "Student";

  const tabsRef = useRef(null);
  const topImage = useRef(null);
  const tabs = floorplanActions.activeTab;

  const [topLine, setTopLine] = useState(
    width < 500 ? (isStudent ? 154 : 106) : 60
  );
  const [topImageClass, setTopImageClass] = useState(
    width < 500
      ? "floorplan-image-wrapper"
      : "floorplan-image-wrapper floorplan-image-wrapper-embedded"
  );

  const [imgClass, setImgClass] = useState("floorplan-image");
  const [headerClass, setHeaderClass] = useState(tabs.unitList);
  const [hasEpanded, setHasExpanded] = useState("");
  const [expandedUnit, setExpandedUnit] = useState(null);

  const addAnimation = () => {
    if (topImage.current) {
      if (
        topImage &&
        topImage.current.getBoundingClientRect().y < 78 &&
        topImage.current.style.height !== "0px"
      ) {
        topImage.current.style.opacity =
          topLine === 106 || topLine === 154 ? 0 : 1;
        topImage.current.style.height =
          topLine === 106 || topLine === 154 ? "0px" : "90px";
      } else if (
        topImage &&
        Math.floor(topImage.current.getBoundingClientRect().y) === topLine
      ) {
        topImage.current.style.opacity = 1;
        topImage.current.style.height =
          topLine === 106 || topLine === 154 ? "250px" : "90px";
      }
    }
  };

  useEffect(() => {
    setImgClass("floorplan-image floorplan-image-animate");
    tabsRef.current.addEventListener("scroll", addAnimation);
  }, []);

  const { bedroom, bathroom, surfaceArea, surfaceAreaTo } = floorplan.info;

  const bedroomDescJsx = bedroom ? (
    <Description className="Description">
      <div className="info-image">
        <span className="info-number">{bedroom.bedrooms}</span>
        <DescImg src={`/images/light-mode/Bed.svg`} />
      </div>
      <span className="info-description">{bedroom.text}</span>
    </Description>
  ) : (
    <Description className="Description">
      <div className="info-image">
        <span className="info-number"> </span>
        <DescImg src={`/images/light-mode/Bed.svg`} />
      </div>
      <span className="info-description">{floorplan.info.type}</span>
    </Description>
  );

  const bathroomDescJsx = bathroom && (
    <Description className="Description">
      <div className="info-image">
        <span className="info-number">{bathroom.bathrooms}</span>
        <DescImg src={`/images/light-mode/Bath.svg`} />
      </div>
      <span className="info-description">{bathroom.text}</span>
    </Description>
  );

  const priceAndDescJsx = surfaceArea && (
    <Description className="Description">
      <div className="info-image">
        <span className="info-number">
          {surfaceArea}
          {surfaceAreaTo != surfaceArea ? "-" + surfaceAreaTo : ""}
        </span>
      </div>
      <span className="info-description">{floorplan.info.surfaceAreaUnit}</span>
    </Description>
  );

  const getMaps = () => {
    getUnitsData({
      gaEvent: "Community Map",
      subType: "text",
      text: "Community Map",
      message: "CommunityMap-CommunityMapConversation",
      type: "text-quicklinks",
      value: "CommunityMap-CommunityMapConversation",
    });
  };

  const changeTab = (tab) => {
    setActiveTab(tab);
    setHeaderClass(tab);
    setUnit(null);
    setExpandedUnit(null);
    if (tab === tabs.unitMap) {
      getMaps();
    }
  };

  const setActiveUnit = (unit) => {
    setUnit(unit);
    setExpandedUnit(null);
    if (unit) {
      setActiveTab(tabs.unitMap);
      getMaps();
    }
  };

  const [likedUnits, setLikedUnits] = useState(
    localStorage.getItem("likedUnits")
      ? JSON.parse(localStorage.getItem("likedUnits"))
      : []
  );

  useEffect(() => {
    localStorage.setItem("likedUnits", JSON.stringify(likedUnits));
  }, [likedUnits]);

  const likeUnit = (el) => {
    const likedUnitsNew = [...likedUnits];
    if (
      likedUnits.find(
        (unit) =>
          unit.unit === el.id && unit.floorplan === floorplan.floorplan_id
      )
    ) {
      let removeIndex = likedUnitsNew.findIndex(
        (unit) =>
          unit.floorplan === floorplan.floorplan_id && unit.unit === el.id
      );
      likedUnitsNew.splice(removeIndex, 1);
    } else {
      likedUnitsNew.push({ floorplan: floorplan.floorplan_id, unit: el.id });
    }
    setLikedUnits(likedUnitsNew);
  };

  const sendLikedUnits = () => {
    return likedUnits
      .filter((unit) => unit.floorplan === floorplan.floorplan_id)
      .map((unit) => unit.unit)
      .toString();
  };

  const QuickLinkType = quickLinkTypes["text-quicklinks"];

  const handleImageLoadFail = (e) => {
    e.target.src =
      process.env.REACT_APP_AWS_URL +
      "uploads/floorplans/default.png?h=500&w=620&zc=2";
  };

  const getNotifyQuickLink = {
    text: translate("Get Notified", language(tid)),
    value: "Floorplans-Other-AvailabilityConversation",
    subType: "text",
    gaEvent: "Get Notified",
  };

  let wordEn;
  let wordEs;
  if(isStudent) {
    let inputString = floorplan.term[0].name
    const regexEn = /<en>(.*?)<\/en>/;
    const regexEs = /<es>(.*?)<\/es>/;

    inputString.match(regexEn) ? wordEn = inputString.match(regexEn)[1] : wordEn = floorplan.term[0].name;
    inputString.match(regexEs) ? wordEs = inputString.match(regexEs)[1] : wordEs = floorplan.term[0].name;  
  }


  return (
    <UnitListFloorplansWrapper className={headerClass}>
      {width < 500 && (
        <>
          <div className="back-button-floorplan">
            <span className="arrow-back" onClick={() => backFloorplans()}>
              {leftBackArrow}
            </span>
            <span className="florplan-name">{floorplan.name}</span>
          </div>

          {isStudent && (
            <div className="floorplan-terms ">
              <span>{translate("Term:", language(tid))}</span>
              {lang === "English" ? wordEn : wordEs}
            </div>
          )}
        </>
      )}
      <UnitList className={`UnitList, ${hasEpanded}`} ref={tabsRef}>
        {(activeTab === tabs.unitList || width >= 500) && (
          <div className={topImageClass} ref={topImage}>
            <div
              className="embeded-back-button"
              onClick={() => backFloorplans()}
            >
              {width >= 500 && leftBackArrowEmbedded}
              {width >= 501 && activeTab === tabs.unitList && "back"}
            </div>
            <img
              className={imgClass}
              onError={handleImageLoadFail}
              src={
                process.env.REACT_APP_AWS_URL +
                "uploads/floorplans/" +
                floorplan.src +
                "?h=500&w=620&zc=2"
              }
              // src="/images/floor-a.jpg"
            />

            <div className="info-wrapper">
              {width >= 500 && (
                <>
                  <div className="floorPlanName">{floorplan.name}</div>
                  {isStudent && (
                    <div className="embeded-term">
                      <span>{translate("Term:", language(tid))}</span>
                      {lang === "English" ? wordEn : wordEs}
                    </div>
                  )}
                </>
              )}
              {bedroomDescJsx}
              {bathroomDescJsx}
              {priceAndDescJsx}
            </div>
          </div>
        )}

        <TabsContainer
          className={`tab-container ${
            activeTab !== tabs.unitList && "other-tabs"
          }`}
        >
          <Tab
            className={`${activeTab === tabs.unitList && "active-tab"} ${
              !data.virtual_tours.length && !data.has_map && "disable-tab"
            }`}
            onClick={() => changeTab(tabs.unitList)}
          >
            <div className="icons">
              {activeTab === "unitList" && (
                <div className="light-icon">{ newBranding === "1" ? unitIconGreen : unitIconLight}</div>
              )}
            </div>
            <div className="tab-name">{ isStudent ? translate("Room types", language(tid)) : translate("Units", language(tid))}</div>
          </Tab>
          {data.virtual_tours.length ? (
            <Tab
              className={activeTab === tabs.virtualTour && "active-tab"}
              onClick={() => changeTab(tabs.virtualTour)}
            >
              <div className="icons">
                {activeTab === "virtualTour" && (
                  <div className="light-icon">{ newBranding === "1" ? virtualIconGreen : virtualIconLight}</div>
                )}
              </div>
              <div className="tab-name">
                {translate("Virtual Tours", language(tid))}
              </div>
            </Tab>
          ) : null}
          {data.has_map === 1 && (
            <Tab
              className={activeTab === tabs.unitMap && "active-tab"}
              onClick={() => changeTab(tabs.unitMap)}
            >
              <div className="icons">
                {activeTab === "unitMap" && (
                  <div className="light-icon"> { newBranding === "1" ? unitMapIconGreen : unitMapIconLight}</div>
                )}
              </div>
              <div className="tab-name">{translate("Map", language(tid))}</div>
            </Tab>
          )}
        </TabsContainer>
        {/* UNITS TAB */}
        {activeTab === tabs.unitList && data.units && (
          <UnitDetails
            info={data.info}
            likedUnits={likedUnits}
            floorplan={floorplan}
            selectUnit={setActiveUnit}
            likeUnit={(e) => likeUnit(e)}
            showPrice={floorplan.floorplan_pricing !== "0"}
            tid={tid}
            setExpandedUnit={setExpandedUnit}
            list={width < 1024}
            dataUnits={data.units}
            lang={lang}
            newBranding={newBranding}
          ></UnitDetails>
        )}
        {activeTab === tabs.unitList && !data.units && (
          <EmptyState>
            <div className="notify-button">
              {data.get_notified === 1 && (
                <div>
                  <span>
                    {translate(
                      "No Available Units At The Moment",
                      language(tid)
                    )}
                  </span>
                  <div onClick={() => backFloorplans()}>
                    <QuickLinkType
                      key="quickLinkNotify"
                      data={getNotifyQuickLink}
                      specials
                      className="notify-button"
                    />
                  </div>
                </div>
              )}
              {data.get_notified !== 1 && (
                <div className="no-units-redirect">
                  <div className="redirect-title">
                    {translate(
                      "You are going to leave the chat",
                      language(tid)
                    )}
                  </div>
                  <div className="redirect-info">
                    {translate(
                      "You are going to be redirected to a page outside of this conversation.",
                      language(tid)
                    )}
                  </div>
                  <a
                    className="notify-button-redirect"
                    href={
                      data.availability
                        ? data.availability
                        : data.unit_availability
                    }
                    target="_blank"
                  >
                    {translate("View Units", language(tid))}
                  </a>
                </div>
              )}

              {data.get_notified !== 1 &&
                !data.availability &&
                !data.unit_availability &&
                !isStudent && (
                  <div className="no-units-redirect">
                    <div className="redirect-title">
                      {translate("No units available", language(tid))}
                    </div>
                  </div>
                )}
            </div>
          </EmptyState>
        )}

        {/* VIRTUAL TOUR TAB */}
        {activeTab === tabs.virtualTour && <VirtualTour></VirtualTour>}
        {/* UNIT MAP TAB */}
        {activeTab === tabs.unitMap && (
          <MapWrapper>
            {mapLoading && (
              <div className="loading-wrapper">
                <Loading
                  alt="loading search"
                  src={window.location.origin + "/images/loading-search.gif"}
                />
              </div>
            )}
            <UnitCarousel className="UnitCarousel" responsive={responsive}>
              {unitMap.map((el, key) => {
                return (
                  <EngrainMap
                    data={el}
                    key={key}
                    activeUnit={activeUnit ? [activeUnit] : floorplanUnits}
                  ></EngrainMap>
                );
              })}
            </UnitCarousel>
          </MapWrapper>
        )}
        {expandedUnit && (
          <InfoUnit
            info={data.info}
            hasLike={likedUnits.find(
              (unit) =>
                unit.unit === expandedUnit.id &&
                unit.floorplan === floorplan.floorplan_id
            )}
            likeUnit={(e) => likeUnit(e)}
            showPrice={floorplan.floorplan_pricing !== "0"}
            tid={tid}
            selectUnit={setActiveUnit}
            el={expandedUnit}
            setExpandedUnit={setExpandedUnit}
            hasMap={floorplan.has_map}
            mapLoading={mapLoading}
            unitMap={unitMap}
            activeUnit={activeUnit}
            getUnitsData={getUnitsData}
            lang={lang}
            floorplan={floorplan}
            newBranding={newBranding}
          ></InfoUnit>
        )}
      </UnitList>

      <QuickLinksWrapper className="QuickLinksWrapper" specials>
        <div className="intents-wapper" onClick={() => backFloorplans()}>
          {quickLinks.map((quicklink, key) => {
            let updatedQuickLink = {
              ...quicklink,
              value: `${quicklink.value}?${sendLikedUnits()}`,
            };
            return (
              <QuickLinkType
                key={`quickLinks-${key}`}
                data={updatedQuickLink}
                specials
                className="back-button"
              />
            );
          })}
        </div>
      </QuickLinksWrapper>
    </UnitListFloorplansWrapper>
  );
}

const mapStateToProps = (state) => ({
  data: state.floorplan.selectedFloorplan,
  activeTab: state.floorplan.activeUnitTab,
  unitMap: state.floorplan.unitMapData,
  floorplanUnits: state.floorplan.floorPlanUnits,
  activeUnit: state.floorplan.selectedUnit,
  mapLoading: state.floorplan.mapLoading,
  floorplan: state.floorplan.selectedFloorplan,
  quickLinks: state.floorplan.quickLinks,
  tid: state.settings.tid,
  unit: state.floorplan.unit,
  lang: state.settings.language,
  newBranding: state.settings.new_branding,
});

const mapDispatchToProps = {
  setActiveTab: floorplanActions.setActiveTab,
  getUnitsData: floorplanActions.getUnitsData,
  setUnit: floorplanActions.setUnit,
  backFloorplans: floorplanActions.backFloorplans,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnitListFloorplans);
